import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormHelpMixin } from '../../mixins/components/FormHelpMixin';
import { FormFieldContext } from '../../js/FormFieldContext';
export var StyledFormHelp = /*#__PURE__*/styled.p.withConfig({
  displayName: "StyledFormHelp",
  componentId: "c11n-8-64-0__sc-h3s6hy-0"
})(["", ""], FormHelpMixin);
var FormHelp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(FormFieldContext),
      descriptionId = _React$useContext.descriptionId,
      error = _React$useContext.error;

  return /*#__PURE__*/React.createElement(StyledFormHelp, _extends({
    ref: ref,
    id: descriptionId || undefined,
    error: error
  }, props));
});
FormHelp.displayName = 'FormHelp';
FormHelp.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Signals that there is an error for the field this is describing.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  error: PropTypes.bool
} : {};
/** @component */

export default FormHelp;